import React from "react";
import Rating from "@material-ui/lab/Rating";
import getProfileLabel from "../../genericFunctions/getProfileLabel";

const PrintRoles = (props) => {
  const roles = props.roles;
  const label = (key) => getProfileLabel(props.language, key);

  return (
    <div
      className="print-font"
      style={{
        paddingRight: "15px",
        maxWidth: "100%",
        marginBottom: "20px",
      }}
    >
      <h3
        style={{
          marginBottom: "10px ",
          background: "#ffffff",
        }}
      >
        {" "}
        {label("roles")}
        <div className="print-border"></div>
      </h3>
      <div>
        {roles.length <= 0 ? (
          <p style={{ marginTop: "1rem", marginBottom: "1rem" }}>
            {label("noRoles")}
          </p>
        ) : (
          roles.map((role) => {
            return (
              <div
                style={{
                  display: "flex",
                  alignItems: "left",
                  flexDirection: "column",
                }}
                key={role._id}
              >
                <p style={{ marginBottom: "0px", fontSize: "1.25rem" }}>
                  {role.name}
                </p>
                <Rating
                  value={parseInt(role.stars)}
                  readOnly
                  style={{ marginBottom: "5px" }}
                />
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default PrintRoles;
